import { useGetLenderApplications } from '@/query/queries/fundraising/useGetLenderApplications';
import { LenderFundraisingDetail } from '../../components/LenderFundraisingDetail';
import { LenderFundraisingEmptyState } from '../../components/LenderFundraisingEmptyState';

export const LenderView = () => {
  const { data: applicationList, isLoading } = useGetLenderApplications();

  if (!applicationList || !applicationList?.length || isLoading) return <LenderFundraisingEmptyState isLoading={isLoading} />;

  return <LenderFundraisingDetail applicationList={applicationList} />;
};